module.exports = __webpack_public_path__ + "static/ArtjokerVCRU-4b9538057e7eac31d95210eae7e10d31.webp";